// Copyright (c) 2020-2021, 2023 Visual Intelligence LP. All rights reserved.
//
import { ImportInformationType } from '@shared/constants/data-management';
import { createFormDataName } from '@shared/utils/file';

// Wrap the file to be imported to html multipart/form-data format.
// The file will be send as {type: code (such as 1 for asset, 2 for platform, ...), file_name_here: file attrs}
export const createFormData = (file: File, type: ImportInformationType) => {
  // Load File obj (which holds attributes such as name, timestamp, content, ...)
  const formData = createFormDataName(file);
  // Set import type.
  formData.append('type', String(type));

  return formData;
};